//create empty dashboard component
import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  template: `
    <div class="dashboard-container">
      <h1>Dashboard</h1>            
        <p>Bem-vindo ao painel de controle do Nucon! Aqui você pode monitorar o status das importações, visualizar estatísticas e acessar relatórios detalhados sobre as denúncias processadas.</p> 
        <p>Use o menu lateral para navegar entre as diferentes seções do sistema, como o status das denúncias, tipos de denúncias, importação de dados e configurações. O dashboard é atualizado em tempo real para fornecer as informações mais recentes sobre o andamento das operações.</p>
        <p>Explore as funcionalidades disponíveis e aproveite ao máximo o Nucon para gerenciar eficientemente as denúncias recebidas.</p>
    </div>
    `,
    styles: [`
      .dashboard-container {
        padding: 2rem;
      }
    `]
})
export class DashboardComponent {}